import ArticlesPage from './articles-page';

export default ArticlesPage;